import { render, staticRenderFns } from "./CommonPriceDetails.vue?vue&type=template&id=40aae17a&"
import script from "./CommonPriceDetails.vue?vue&type=script&lang=ts&setup=true&"
export * from "./CommonPriceDetails.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40aae17a')) {
      api.createRecord('40aae17a', component.options)
    } else {
      api.reload('40aae17a', component.options)
    }
    module.hot.accept("./CommonPriceDetails.vue?vue&type=template&id=40aae17a&", function () {
      api.rerender('40aae17a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/appointment/vrach/new/components/DoctorAppointmentForm/components/PaymentInfo/components/PaymentClub/components/PriceDetails/components/CommonPriceDetails.vue"
export default component.exports